import { render } from "./MediaBox.vue?vue&type=template&id=5594a5c0"
import script from "./MediaBox.vue?vue&type=script&lang=js"
export * from "./MediaBox.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__